/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_Three_Way_PassedInputs */

const en_inbound_status_three_way_passed = /** @type {(inputs: Inbound_Status_Three_Way_PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check passed`)
};

/**
* | output |
* | --- |
* | "Check passed" |
*
* @param {Inbound_Status_Three_Way_PassedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_three_way_passed = /** @type {((inputs?: Inbound_Status_Three_Way_PassedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_Three_Way_PassedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_three_way_passed(inputs)
});